export default __webpack_public_path__ + "static/media/sounds-good.3db8d9a6.gif";